import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Button from "./Button";
import { cn } from "../lib/utils";
import { howItWorksSteps } from "../content/home-sections";

// Pattern: timeleft.com "How it works" tilted 3-card row with a single CTA
// beneath (clone catalogue 2026-06-09). Structure only; design language is ours.
const HowItWorks: React.FC = () => {
  return (
    <section className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-3 py-1 rounded-full border border-salmon/40 bg-paper-salmon text-salmon-dark text-xs font-bold uppercase tracking-widest mb-6">
            How it works
          </span>
          <h2 className="font-serif text-ink tracking-tight leading-[0.95] text-4xl md:text-6xl">
            Strangers to your people, <br className="hidden md:block" />
            <span className="text-gray-400">in three steps.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-14">
          {howItWorksSteps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className={cn(
                "rounded-3xl p-8 md:p-10 flex flex-col gap-4 transition-transform duration-300 hover:rotate-0 hover:-translate-y-1",
                step.rotate,
              )}
              style={{ backgroundColor: step.bg }}
            >
              <div className="flex items-center justify-between">
                <span className="font-serif text-5xl text-ink/20">
                  {step.n}
                </span>
                <step.Icon
                  className="w-7 h-7 text-salmon-dark"
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-ink tracking-tight">
                {step.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{step.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <Button
            size="lg"
            onClick={() =>
              document
                .getElementById("newsletter")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Join the waitlist
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
